import { createContext } from "react";

const ChartWorkspaceCrosshairContext = createContext({
  enabled: false,
  point: null,
  setPoint: null,
});

export default ChartWorkspaceCrosshairContext;
